<template>
  <div>
    <button
      type="button"
      class="btn btn-primary btn-with-addon"
      @click="showModal"
    >
      <span class="btn-addon">
        <i class="btn-addon-icon fe fe-plus-circle" />
      </span>
      Add Product
    </button>

    <a-modal v-model="visible" title="Add new product">
        <template slot="footer">
          <a-button key="back" @click="handleCancel">Close</a-button>
          <a-button key="submit" type="primary" htmlType="submit" :loading="loading" @click="savedata">Submit</a-button>
        </template>

        <a-form class="mb-4" :form="form">
          <div class="row">
            <div class="col-md-6">
              <a-form-item label="Select category">
                <a-select
                  placeholder="Select category"
                  v-decorator="['category_id', { rules: [{ required: true, message: 'Please select a category!'}]}]"
                  @change="handleCategorySelect"
                >
                  <a-select-option v-for="(cat, index) in categories" :key="index" :value="cat.id">{{cat.name}}</a-select-option>
                </a-select>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Select sub category">
                <a-select
                  placeholder="Select sub category"
                  v-decorator="['sub_category_id', { rules: [{ required: false, message: 'Please select a sub category!'}]}]"
                >
                  <a-select-option v-for="(cat, index) in subCategories" :key="index" :value="cat.id">{{cat.name}}</a-select-option>
                </a-select>
              </a-form-item>
            </div>
          </div>
          <a-form-item label="Name">
              <a-input
                  placeholder="Name"
                  v-decorator="['name', {rules: [{ required: true, message: 'Please input category name!' }, {max: 30, message: 'Must not exceed 30 characters!'}]}]"
              />
          </a-form-item>
          <div class="row">
            <div class="col-md-6">
              <a-form-item label="Product Code">
                <a-input
                  placeholder="Product code. eg: SKU1129930"
                  v-decorator="['code', {rules: [{ required: true, message: 'Please input product code!' }, {max: 30, message: 'Must not exceed 30 characters!'}]}]"
                />
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Selling Price">
                <a-input-number
                  style="width: 100%"
                  placeholder="Set the selling price"
                  v-decorator="['selling_price', {rules: [{ required: false, message: 'Please input product code!' }]}]"
                />
              </a-form-item>
            </div>
          </div>
          <a-form-item label="Class">
            <a-select
              v-decorator="[
                    'class_id',
                    {rules: [{ required: false, message: 'Please select a class!!' }], initialValue: 0}
                  ]"
              placeholder="Select class"
            >
              <a-select-option :value="0">
                Select Class
              </a-select-option>
              <template v-for="schoolClass in schoolClasses">
                <a-select-option :value="schoolClass.id" :key="schoolClass.id">
                  {{schoolClass.name}}
                </a-select-option>
              </template>
            </a-select>
          </a-form-item>

          <div class="row">
            <div class="col-md-6">
              <a-form-item label="Minimum Quantity">
                <a-input-number
                  style="width: 100%"
                  placeholder="Add Minimum Quantity"
                  v-decorator="['minimum_quantity', {rules: [{ required: false, message: 'Please input minimum quantity!' }]}]"
                />
              </a-form-item>
            </div>

            <div class="col-md-6">
              <a-form-item label="Maximum Quantity">
                <a-input-number
                  style="width: 100%"
                  placeholder="Add Maximum Quantity"
                  v-decorator="['maximum_quantity', {rules: [{ required: false, message: 'Please input maximum quantity!' }]}]"
                />
              </a-form-item>
            </div>
          </div>
          <a-form-item label="Description">
              <a-textarea placeholder="Description" :autosize="{minRows: 2}" v-decorator="['description', {rules: [{max: 100, message: 'Must not exceed 100 characters!'}]}]" />
          </a-form-item>
        </a-form>
    </a-modal>
  </div>
</template>

<script>

// import { fetchInventoryData } from '@/components/inventory/common'
/* const clearform = (form) => {
  // console.log('form', form)
  // console.log(form.fieldsStore)
  // console.log(Object.keys(form.fieldsStore.fields))
  try {
    let fieldnames = Object.keys(form.fieldsStore.fields)
    fieldnames.map((e, index) => {
      form.setFieldsValue({ [e]: undefined })
    })
  } catch (err) {
    console.error(err)
  }
} */
export default {
  name: 'NewProduct',
  props: {
    formVisible: { type: Boolean, require: true },
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      allCategories: [], // All categories including sub categories
      categories: [], // Only the main categories i.e. without subcategories
      subCategories: [],
      schoolClasses: [],
    }
  },
  mounted: function() {
    // let d = fetchInventoryData('category')
    this.getParentCategories()
    // d.then(data => { this.categories = data.data }).catch(err => console.error(err))
  },
  watch: {
    formVisible: function(n, o) {
      // console.log('formvisible changed??', n)
      this.visible = n
    },
  },
  methods: {
    showModal() {
      this.visible = true
      this.getClasses()
    },
    getParentCategories: function() {
      this.$http.get('/api/inventory/category')
        .then(({ data }) => {
          this.allCategories = data.data
          this.categories = this.allCategories.filter((category) => category.parent_category_id === null)
        })
        .catch(error => {
          console.log(error)
        })
    },
    getSubCategories: function(selectedCategoryId) {
      this.subCategories = this.allCategories.filter((category) => category.parent_category_id === selectedCategoryId)
    },
    handleCategorySelect: function(selectedCategoryId) {
      console.log('selectedCategoryId:: ', selectedCategoryId)
      this.getSubCategories(selectedCategoryId)
    },
    getClasses: function() {
      this.$http.get('/api/class')
        .then(({ data }) => {
          this.schoolClasses = data.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    savedata: function() {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          // clearform(this.form)
          this.$confirm({
            title: `Are you sure you want to add ${values.name}?`,
            content: `Click on the OK button to add the new product!`,
            onOk: () => {
              this.$http.post('/api/inventory/product', {
                name: values.name,
                description: values.description,
                category_id: values.category_id,
                sub_category_id: values.sub_category_id,
                class_id: values.class_id,
                selling_price: values.selling_price ? values.selling_price : 0.0,
                remark: '',
                status: 1,
                code: values.code,
                min_quantity: values.minimum_quantity,
                max_quantity: values.maximum_quantity,
              })
                .then((resp) => {
                  this.$emit('created')
                  this.loading = false
                  this.visible = false
                  if (resp.status === 200 || resp.status === 201) {
                    this.$notification['success']({
                      message: 'Product created successfully',
                      description: `${values.name} added successfully!`,
                    })
                    console.log(resp.data)
                    this.showInwardTransactionModal(resp.data.data)
                  } else {
                    this.$notification['warning']({
                      message: 'Unknown Error',
                      description: `There appears to be an error while submitting data. Response from server: ${resp.status} ${resp.message}`,
                    })
                  }
                  this.form.resetFields()
                })
                .catch((err) => {
                  this.loading = false
                  this.$neoNotify.error(err)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }

        this.loading = false
      })
    },
    handleCancel(e) {
      this.visible = false
    },
    showInwardTransactionModal(record) {
      this.$eventBus.$emit('showInwardTransactionForm', record)
    },
  },
}
</script>

<style>

</style>
